// export const api_URL = "http://localhost:8095/api/";
// export const api_URL = "https://ipmafricmanagement.com/office/api/";
//export const api_URL = "https://portail.mutuelle-artisants-sn.com/office/api/"; 
// export const api_URL = "https://ipmsimus.com/office/api/"; 
// export const api_URL = "https://ipmhygie.com/office/api/";
// export const api_URL = "https://ipmimane.com/office/api/";
// export const api_URL = "https://ipm-tawfeikh.com/office/api/";
// export const api_URL = "https://ipmdslzig.com/office/api/";
// export const api_URL = "https://ipmintermed.com/office/api/";
// export const api_URL = "https://ipmeiffage.com/office/api/";
// export const api_URL = "https://ipmics.com/office/api/";
// export const api_URL = "https://ipmsagam.com/office/api/";
export const api_URL = "https://ipm-ta.com/office/api/";
// export const api_URL = "https://ipmfleuve.com/office/api/";
// export const api_URL = "https://ipmsonacosklk.com/office/api/";
// export const api_URL = "https://ipmprioritesante.com/office/api/";
// export const api_URL = "https://ipmubipharm.com/office/api/";
// export const api_URL = "https://ipmworldvision.com/office/api/";
// export const api_URL = "https://ipmipres.com/office/api/";
// export const api_URL = "https://ipmisra.com/office/api/";
// export const api_URL = "https://ipmpetitecote.com/office/api/";
// export const api_URL = "https://ipmiezig.com/office/api/";
// export const api_URL = "https://ipmodec.com/office/api/";
// export const api_URL = "https://ipmafrirh.com/office/api/";
// export const api_URL = "https://ipmfadiou.com/office/api/";
// export const api_URL = "https://ipmanep.com/office/api/";
// export const api_URL = "https://ipmposte.com/office/api/";
// export const api_URL = "https://ipm-sentenac.com/office/api/";
// export const api_URL = "http://10.100.5.101:8094/api/";
// export const api_URL = "http://SRV-APPS:8087/api/";

export const api_DisplayName = new URL(api_URL).hostname.split('.')[0];
export const SECRET_KEY = "mmskoijdiedt356sjygs@jhushllpllplfcfrft"